module.exports = __webpack_public_path__ + "static/img/TransparencyLogo.9957347.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Menu/TransparencyLogo.svg
// module id = 1660
// module chunks = 32 36 37 38